import { render, staticRenderFns } from "./eComplaintFiltersModal.vue?vue&type=template&id=504368c4"
import script from "./eComplaintFiltersModal.vue?vue&type=script&lang=js"
export * from "./eComplaintFiltersModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports